export class ForgotPasswordModel {

    public email: string = "";
    public submitted: boolean = false;
    public error: string = null;

}
